import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { SetUserDatas, UpdateUserDatas } from '../actions/user-datas.actions';

export interface UserStateModel {
  user: any;
}

@State<UserStateModel>({
  name: 'user',
  defaults: {
    user: null,
  },
})
@Injectable()
export class UserState {
  @Selector()
  static getUserDatas(state: UserStateModel) {
    return state.user;
  }

  @Action(SetUserDatas)
  setUserDatas(ctx: StateContext<UserStateModel>, action: SetUserDatas) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      user: action.payload,
    });
  }

  @Action(UpdateUserDatas)
  updateUserDatas(ctx: StateContext<UserStateModel>, action: UpdateUserDatas) {
    const state = ctx.getState();
    ctx.patchState({
      user: {
        ...state.user,
        ...action.payload,
      },
    });
  }
}
